export default __webpack_public_path__ + "static/media/zeroshotbot_black.dd2c6031.png";